import { Box } from "@mui/material";

import { PostMediaLayoutProps } from "../../../../types/components/props.type";

import MediaCard from "./MediaCard";

const PostMediaLayout = ({ visibleMedia, extraMediaCount, onClickOnMedia }: PostMediaLayoutProps) => {
  const count = visibleMedia.length;
  const gap = "4px";

  switch (count) {
    case 1:
      return (
        <Box sx={{ width: "100%", height: "100%" }}>
          <MediaCard
            item={visibleMedia[0]}
            index={0}
            extraMediaCount={extraMediaCount}
            handleClickOnMedia={onClickOnMedia}
          />
        </Box>
      );

    case 2:
      return (
        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap, width: "100%", height: "100%" }}>
          {visibleMedia.map((item, index) => (
            <MediaCard
              key={item.id}
              item={item}
              index={index}
              extraMediaCount={extraMediaCount}
              handleClickOnMedia={onClickOnMedia}
            />
          ))}
        </Box>
      );

    case 3:
      return (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridTemplateRows: "repeat(4, 1fr)",
            gap,
            width: "100%",
            height: "100%",
          }}
        >
          <Box sx={{ gridColumn: "1", gridRow: "1 / span 4" }}>
            <MediaCard
              item={visibleMedia[0]}
              index={0}
              extraMediaCount={extraMediaCount}
              handleClickOnMedia={onClickOnMedia}
            />
          </Box>
          <Box sx={{ gridColumn: "2", gridRow: "1 / span 2" }}>
            <MediaCard
              item={visibleMedia[1]}
              index={1}
              extraMediaCount={extraMediaCount}
              handleClickOnMedia={onClickOnMedia}
            />
          </Box>
          <Box sx={{ gridColumn: "2", gridRow: "3 / span 2" }}>
            <MediaCard
              item={visibleMedia[2]}
              index={2}
              extraMediaCount={extraMediaCount}
              handleClickOnMedia={onClickOnMedia}
            />
          </Box>
        </Box>
      );

    case 4:
      return (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridTemplateRows: "1fr 1fr",
            gap,
            width: "100%",
            height: "100%",
          }}
        >
          {visibleMedia.map((item, index) => (
            <MediaCard
              key={item.id}
              item={item}
              index={index}
              extraMediaCount={extraMediaCount}
              handleClickOnMedia={onClickOnMedia}
            />
          ))}
        </Box>
      );

    default:
      return (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridTemplateRows: "repeat(6, 1fr)",
            gap,
            width: "100%",
            height: "100%",
          }}
        >
          <Box sx={{ gridColumn: "1", gridRow: "1 / span 3" }}>
            <MediaCard
              item={visibleMedia[0]}
              index={0}
              extraMediaCount={extraMediaCount}
              handleClickOnMedia={onClickOnMedia}
            />
          </Box>
          <Box sx={{ gridColumn: "1", gridRow: "4 / span 3" }}>
            <MediaCard
              item={visibleMedia[1]}
              index={1}
              extraMediaCount={extraMediaCount}
              handleClickOnMedia={onClickOnMedia}
            />
          </Box>
          <Box sx={{ gridColumn: "2", gridRow: "1 / span 2" }}>
            <MediaCard
              item={visibleMedia[2]}
              index={2}
              extraMediaCount={extraMediaCount}
              handleClickOnMedia={onClickOnMedia}
            />
          </Box>
          <Box sx={{ gridColumn: "2", gridRow: "3 / span 2" }}>
            <MediaCard
              item={visibleMedia[3]}
              index={3}
              extraMediaCount={extraMediaCount}
              handleClickOnMedia={onClickOnMedia}
            />
          </Box>
          <Box sx={{ gridColumn: "2", gridRow: "5 / span 2" }}>
            <MediaCard
              item={visibleMedia[4]}
              index={4}
              extraMediaCount={extraMediaCount}
              handleClickOnMedia={onClickOnMedia}
            />
          </Box>
        </Box>
      );
  }
};

export default PostMediaLayout;
